import { css, flex, Container, Text, Card, tokens } from "@balabalabom/ui";

export function About() {
  return (
    <Container>
      <Card
        variant="elevated"
        style={css({
          backgroundColor: "#fef7e0",
          margin: "3rem auto",
          textAlign: "center",
        })}
      >
        <div
          style={{
            ...flex({ direction: "column", align: "center" }),
          }}
        >
          {/* Illustration */}
          <div style={css({ maxWidth: "600px", marginBottom: "3rem" })}>
            <img
              src="/about-page-mom-reading.png"
              alt="Woman reading to children"
              style={css({
                width: "100%",
                height: "auto",
                borderRadius: tokens.borderRadius.lg,
              })}
            />
          </div>

          {/* Heading */}
          <Text
            as="h2"
            variant="heading2"
            style={css({
              marginBottom: "2rem",
              lineHeight: "1.2",
            })}
          >
            Hi, I'm a mom of two and a senior web developer from a multilingual
            family.
          </Text>

          {/* Description */}
          <Text
            variant="bodyLarge"
            style={css({
              maxWidth: "900px",
            })}
          >
            Welcome to my Balabalabom space! What began as a simple bilingual
            story time for my toddler and newborn—so they could hear Chinese and
            English in a warm, playful setting—has grown into a community hobby.
            Each month, I also run hands-on, beginner-friendly tech workshops to
            help families access technology, get practical answers, and build
            small projects together. All events are self-funded and scheduled
            around our family routine, so availability may vary—thank you for
            understanding and for your interest. I can’t wait to learn, play,
            and create with you in person!
          </Text>

          {/* Contact */}
          <div
            style={css({
              marginTop: "2.5rem",
              paddingTop: "2rem",
              borderTop: `1px solid ${tokens.colors.neutral[200]}`,
              ...flex({ direction: "column", gap: "0.5rem", align: "center" }),
            })}
          >
            <Text variant="bodyLarge" style={css({ fontWeight: 600 })}>
              Contact
            </Text>
            <a
              href="mailto:admin@balabalabom.com"
              style={css({
                color: tokens.colors.brand.primary,
                textDecoration: "none",
                "&:hover": { textDecoration: "underline" },
              })}
            >
              admin@balabalabom.com
            </a>
            <a
              href="tel:+15127668231"
              style={css({
                color: tokens.colors.brand.primary,
                textDecoration: "none",
                "&:hover": { textDecoration: "underline" },
              })}
            >
              512-766-8231
            </a>
          </div>
        </div>
      </Card>
    </Container>
  );
}
